export abstract class IMonitoringRepository {
  generateAvailabilityChartUrl: (
    availabilityZoneIds: number[],
    chartWidth: number,
    chartHeight: number,
    historyMinutes: number,
    graphDurationSecs: number,
    timeTagFormat: string,
    vertLineEvery: number,
    hoursInstead: boolean,
  ) => string;
  generateChannelTargetChartUrl: (
    platformId: number,
    availabilityZoneId,
    chartWidth: number,
    chartHeight: number,
    historyMinutes: number,
    graphDurationSecs: number,
    timeTagFormat: string,
    vertLineEvery: number,
    hoursInstead: boolean,
  ) => string;
}
